import React, { Component } from 'react';
import style from './rightbar.less';
import _ from '../../i18n.jsx';
import iconsStyle from '../../styles/icons.less';
import className from 'classnames';
import { setActivePage, setFieldValue } from '../../app.reducer.jsx';
import { bindActionCreators } from '../../app.store.jsx';
import { animateScrollToPage } from '../../questionnaire.utils.jsx';

export default class RightBar extends Component {
    render() {
        const { lastPageIndex, currentPageIndex, pageList, fields } = this.props;
        const startPageIndex = 0;
        const _fields = fields.toJS();
        const finished = _fields.finished;
        let nextPageIndex = currentPageIndex + 1,
            prevPageIndex = currentPageIndex - 1;
        const pageListSize = pageList.length;
        if (0 < pageListSize) {
            const nextPageCondition = currentPageIndex + 1 < pageList.length ? pageList[currentPageIndex + 1].condition || null : null;
            const prevPageCondition = 1 < currentPageIndex ? pageList[currentPageIndex - 1].condition : null;
            if (nextPageCondition && !nextPageCondition(_fields)) { nextPageIndex++; }
            if (prevPageCondition && !prevPageCondition(_fields)) { prevPageIndex--; }
        }
        const props = { pageListSize, lastPageIndex };
        const rightBarClassName = className(style.rightBar, { [style.hidden]: finished });
        const { STRINGS, ICONS } = RightBar;
        const centerButtonClass = className(style.rightBarBtn, style.centerBtn);
        return (
            <nav tabIndex="-1" className={rightBarClassName}>
                <RightBarButton {...props} iconTitle={STRINGS.START} iconName={ICONS.START} navigateTo={startPageIndex}/>
                <RightBarButton {...props} iconTitle={STRINGS.PREVIOUS} iconName={ICONS.PREVIOUS} navigateTo={prevPageIndex}/>
                <div className={centerButtonClass}></div>
                <RightBarButton {...props} iconTitle={STRINGS.NEXT} iconName={ICONS.NEXT} navigateTo={nextPageIndex}/>
                <RightBarButton {...props} iconTitle={STRINGS.FINISH} iconName={ICONS.FINISH} navigateTo={lastPageIndex}/>
            </nav>
        );
    }
}

export class RightBarButton extends Component {
    constructor() {
        super();
        this.navigate = this.navigate.bind(this);
        this._setActivePage = bindActionCreators(setActivePage);
        this._setFieldValue = bindActionCreators(setFieldValue);
    }
    navigate() {
        const { navigateTo, pageListSize, lastPageIndex } = this.props;
        if (0 <= navigateTo && navigateTo < pageListSize && navigateTo <= lastPageIndex) {
            this._setActivePage(navigateTo);
            this._setFieldValue('currentPageIndex', navigateTo, 'pages');
            animateScrollToPage(navigateTo);
        }
    }
    render() {
        const { iconName, iconTitle, btnId } = this.props;
        return (
            <div className={style.rightBarBtn} onClick={this.navigate}>
                <a id={btnId} className={style.rightBarBtn__btn}>
                    <span className={className(iconsStyle[`icon-${iconName}`], style.rightBarBtn__icon)}></span>
                    {iconTitle}
                </a>
            </div>
        );
    }
}

RightBar.STRINGS = {
    START: _('Start'),
    FINISH: _('Finish'),
    NEXT: _('Next'),
    PREVIOUS: _('Prev')
};

RightBar.ICONS = {
    START: 'start',
    FINISH: 'finish',
    NEXT: 'next',
    PREVIOUS: 'prev'
};
